import {Image} from '@/lib/target';
import { useMatchData } from "@/hooks/useMatchData";
import MatchHeader from '@/components/server/MatchHeader';
import { use, useState } from 'react';

const Match = ({ matchId }) => {
  const {matchLive} = useMatchData(matchId);
  const match = matchLive;
  
  return (
    (match && (
      
    <div className="flex justify-between @lg:justify-center p-4 @md:mb-5">
      <div className="flex flex-col items-center justify-center dark:text-league-dark-detail w-100 @md:w-160">
        <div className="w-40 @md:w-80 flex justify-center">
          <Image
            src={match?.homeTeam?.logo || 'https://demofree.sirv.com/nope-not-here.jpg'}
            alt={"Net88"}
            layout="responsive"
            width={40}
            height={40}
            sizes="(max-width: 640px) 100px, (max-width: 1024px) 150px, 200px"
            priority={true}
          />
        </div>
        <p className="text-sm @md:text-base font-semibold text-center mt-6 text-dark-gray dark:text-league-dark-detail">{match?.homeTeam?.name}</p>
      </div>
      <MatchHeader matchDB={match}/>
      <div className="flex flex-col items-center justify-center dark:text-league-dark-detail w-100 @md:w-160">
        <div className="w-40 @md:w-80  flex justify-center">
          <Image
            src={match?.awayTeam?.logo || 'https://demofree.sirv.com/nope-not-here.jpg'}
            alt={"Net88"}
            layout="responsive"
            width={40}
            height={40}
            sizes="(max-width: 640px) 100px, (max-width: 1024px) 150px, 200px"
            priority={true}
          />
        </div>
        <p className="text-sm @md:text-base font-semibold text-center mt-6 text-dark-gray dark:text-league-dark-detail">{match?.awayTeam?.name}</p>
      </div>
    </div>
    ))
  );
};

const MatchLabel = ({ label }) => {
  return (
    <div className="flex items-center bg-button-blue-bet dark:bg-league-header-dark text-white-half dark:text-golden-yellow font-semibold rounded w-full px-3 py-1 text-sm">
      {label}
    </div>
  );
}

const MatchNavigation = ({onClickTab}) => {

  const [activeTab, setActiveTab] = useState('chitiet');

  const handleOnClickNav = (tab) => {
    setActiveTab(tab);
    onClickTab(tab);
  };

  const getLinkClass = (tab) => {    
    return `h-full w-full flex items-center justify-center @md:py-1.5 @md:px-4 rounded
      ${activeTab === tab ? "bg-button-blue-bet relative active text-[#FFFFFF]" : "dark:text-[#BCBCBC] hover:text-[#FFFFFF] dark:hover:text-dark-gray"}`;
  };
  
  const isActiveLink = () => false;  

  return (
    <nav className="border-b-golden-yellow border-solid border-b-2">
      <ul className="h-7 flex bg-white  dark:bg-league-dark text-xs font-semibold w-full justify-center @md:justify-start rounded @md:w-fit">
        <li className="w-1/3 @md:w-fit text-center hover:bg-button-blue-bet  rounded">
          <button className={getLinkClass('chitiet')} onClick={() => handleOnClickNav('chitiet')}>
            Chi tiết
          </button>
        </li>
        <li className={`text-league-dark-detail flex items-center ${isActiveLink("/phan-tich") || isActiveLink("/chi-tiet") ? "invisible" : ""}`}> | </li>
        <li className="w-1/3 @md:w-fit text-center hover:bg-button-blue-bet hover:text-[#FFFFFF] rounded">
          <button  className={getLinkClass('phantich')} onClick={() => handleOnClickNav('phantich')}>
            Phân tích
          </button>
        </li>
        <li className={`text-league-dark-detail flex items-center ${isActiveLink("/phan-tich") || isActiveLink("/so-sanh-ti-le") ? "invisible" : ""}`}> | </li>
        <li className="w-1/3 @md:w-fit text-center hover:bg-button-blue-bet hover:text-[#FFFFFF] rounded">
          <button className={getLinkClass('sosanhtile')} onClick={() => handleOnClickNav('sosanhtile')}>
            So sánh tỉ lệ
          </button>
        </li>
      </ul>
    </nav>
  );
};

export { Match, MatchLabel, MatchNavigation };